<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl [dato]="dato" titulo="Repetición / Regularización" url="repeticion"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando" align="center" id="banner">
    <div class="bloquear-azul"></div>
    <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
        <span class="icon">
            <i class="icon-worldwide fa-spin"></i>
        </span> &nbsp;
    <span>Cargando...</span>
    </span>
</div>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; height:100%;">

            <!-- formulario -->
            <form (ngSubmit)="ctrl.enviar()" name="form" novalidate>
                <section class="hero is-primary">
                    <div class="hero-body">
                        <a (click)="ctrl.cargarCatalogo('logos64', 'logos64?carreras_planes_id=null', 'logo64'); ctrl.cargarCatalogo('periodos_escolares_vigentes', 'periodo-escolar-vigente');" id="catalogos"></a>
                        <a (click)="asignarLogos(ctrl.logos64); " id="logo64"></a>
                        <!-- <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares_vigentes', 'periodo-escolar-vigente');"></a> -->
                        <!-- <a id="cargar-grupo" (click)="cargar_grupo('periodo-escolar');"></a> -->
                        <!-- <a id="message" (click)="ctrl.mostrar_mensaje(titulo, mensaje, clase);"></a> -->
                        <!-- Opciones  -->
                        <section class="hero is-primary">
                            <div class="hero-head">
                                <nav class="level">
                                    <!-- Left side -->
                                    <div class="level-left">
                                        <div class="level-item">
                                            <p class="title">
                                                <span *ngIf="!ctrl.cargando" class="icon is-medium">
                                                    <i class="icon-insurance"></i>
                                                </span>
                                                <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                                                    <i class="icon-worldwide fa-spin"></i>
                                                </span>
                                                <span class="icon is-medium">
                                                    <i class="icon-file"></i>
                                                </span> Repetición
                                            </p>
                                        </div>

                                    </div>

                                    <!-- Right side -->
                                    <div class="level-right">

                                        <a (click)="ctrl.regresar()" class="navbar-item is-primary tooltip">
                                            <span class="icon fa-2x">
                                                <i class="icon-back"></i>
                                            </span>
                                            <span class="tooltiptext">Regresar</span>
                                        </a>

                                        <a (click)="cargarDatos(alumnos.id)" *ngIf="alumnos.id != ''" class="navbar-item is-primary tooltip" id='cargar_datos_actualizar'>
                                            <span class="icon fa-2x">
                                                <i class="icon-worldwide"></i>
                                            </span>
                                            <span class="tooltiptext">Actualizar</span>
                                        </a>

                                        <button (click)="ctrl.abrirModal('confirmarCalificacion')" *ngIf="!tieneid" [disabled]="cargando" [ngClass]="{'is-loading': cargando}" class="navbar-item  tooltip" type="button">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-diskette"></i>
                                            </span>
                                            <span class="tooltiptext">Guardar</span>
                                        </button>
                                    </div>
                                </nav>
                            </div>
                        </section>
                    </div>
                </section>

                <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">
                    <section class="hero is-primary">
                        <div class="hero-body">
                            <nav class="level ">
                                <!-- Left side -->
                                <div class="level-left ">
                                    <div class="level-item">
                                        <p class="title">
                                            <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium">
                                                <i class="icon-edit-1"></i>
                                            </span> Buscar alumnos
                                        </p>
                                    </div>
                                </div>
                                <div class="level-right " style=" width: 78%; ">
                                    <div class="level-item" style=" width: 100%; ">
                                        <div class="control has-icons-left is-expanded" style=" width: 100%; ">
                                            <input (valueChanged)="select_articulo_autocomplete($event)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false" [source]="observableSource.bind(this)" autocomplete="off" autofocus class="input is-success is-medium" display-property-name="id" id='buscarArticulo' loading-text="Cargando..."
                                                min-chars="3" ngui-auto-complete no-match-found-text="No hay resultados." path-to-data="" placeholder="Escribe el nombre del alumno, o la matrícula" type="text" value-property-name="id">
                                            <span class="icon is-medium is-left">
                                                <i class="icon-search3"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </section>
                    <div *ngIf="cargando" class="is-fullwidth has-text-centered">
                        <br>
                        <span class="tag is-primary is-large ">
                            <span class="icon">
                                <i class="icon-worldwide fa-spin"></i>
                            </span> &nbsp;
                        <span>Cargando...</span>
                        </span>
                    </div>

                    <section style="padding: .1rem !important; overflow:auto;">

                        <div *ngIf="!ctrl.cargando || !cargando" class="box">
                            <article class="media">
                                <div class="media-left">
                                    <figure class="image is-64x64">
                                        <img [src]="alumnos.alumnos_metadatos.foto != null ? ctrl.API_PATH+'/adjunto/alumnos/'+alumnos.alumnos_metadatos.foto : alumnos.alumnos_metadatos.avatar != null ? alumnos.alumnos_metadatos.avatar : './assets/128x128.png'" alt="Image">
                                    </figure>
                                </div>
                                <div class="media-content" style="padding: 1.2em;">
                                    <div class="content">
                                        <p>
                                            <strong>
                                                {{alumnos.alumnos_metadatos.nombre }}
                                            </strong>
                                            <small>{{alumnos.alumnos_metadatos.email}}</small>
                                            <!-- <span>
                                                Grupo:
                                                {{alumnos.grupos.clave}}</span>
                                            <span>
                                                Nivel:
                                                {{alumnos.grupos.nivel}}
                                                {{alumnos.grupos.identificador}}</span>
                                            <span>
                                                Beca:
                                                {{alumnos.becas ? alumnos.becas.becas.nombre : 'Sin beca'}}</span>
                                            <br>
                                            <strong>
                                                Carrera Plan:</strong> {{alumnos.carrera_plan.nombre}}
                                            <strong>
                                                Carrera:</strong> {{alumnos.carreras.nombre}}
                                            <br>
                                            <strong>
                                                Modalidad:</strong> {{alumnos.modalidades.nombre}} -->


                                            <!-- <button (click)="imprimirKardex(dato)" *ngIf="dato[0]" class="navbar-item " style="float: right;" type="button">
                                                                                            <span class="icon fa-2x has-text-black"></span>
                                                                                            <span [ngClass]="(dato[0][0] * 1) > carrera_plan.minimo_aprobatorio ? 'has-text-success' : 'has-text-danger'" style="font-weight: 900">PROMEDIO GENERAL:
                                                                                                {{dato[0][0]}}</span>
                                                                                        </button>
                                            
                                                                                        <button (click)="imprimirKardex(dato)" class="navbar-item  tooltip" style="float: right;" type="button">
                                                                                            <span class="icon fa-2x has-text-black">
                                                                                                <i class="icon-printer"></i>
                                                                                            </span>
                                                                                            <span class="tooltiptext">Imprimir Kardex</span>
                                                                                        </button> -->
                                        </p>

                                    </div>
                                </div>
                            </article>
                        </div>
                    </section>

                    <section style="padding: 1.1rem !important; overflow:auto;">
                        <div class="columns">
                            <div class="column is-4">
                                <label class="label">Materias:</label>
                                <div class="control has-icons-left has-icons-right">
                                    <!-- <div class="select">
                                        <select class="select" id="materias_id" (change)="cM();">
                                            <option value=" ">Seleccione</option>
                                            <option *ngFor="let item of materias " value="{{item.id}} ">{{item.clave}} - N {{item.nivel}} : {{item.nombre}}</option>
                                        </select>
                                    </div> -->
                                    <div class="select ">
                                        <ng-select2 [disabled]="materias ? materias.length==0 ? true : false : true " (valueChanged)="sCE($event, 'materias_id');" [options]="ctrl.optionSelect " [data]="materias "></ng-select2>
                                    </div>

                                  <!--   <span class="icon is-small is-right ">
                                        <i class="fa fa-warning "></i>
                                    </span>
                                    <span class="help is-danger ">Este campo es requerido.</span> -->
                                </div>
                            </div>

                            <div class="column is-4 ">
                                <div class="control has-icons-left has-icons-right ">
                                    <label class="label ">Periodo escolar:</label>
                                    <ng-select2 (valueChanged)=" sCE($event, 'periodos_escolares_id'); ctrl.grupos=[ ]; ctrl.cargarCatalogo( 'grupos', 'grupo?periodos_escolares_id='+ctrl.dato[ 'periodos_escolares_id']); " [disabled]="ctrl.periodos_escolares_vigentes
                                            ? ctrl.periodos_escolares_vigentes.length==0 ? true : false : true " name="periodos_escolares_id " [options]="ctrl.optionSelect " [data]="ctrl.periodos_escolares_vigentes ">
                                    </ng-select2>

                                    <!-- <span class="icon is-small is-right " *ngIf="ctrl.dato.get( 'periodos_escolares_id').hasError( 'required') ">
                      <i class="fa fa-warning "></i>
                    </span>
                                    <span class="help is-danger " *ngIf="ctrl.dato.get( 'periodos_escolares_id').hasError( 'required') ">Este
                      campo es requerido.</span> -->
                                </div>
                            </div>

                            <div class="column is-4 ">
                                <label class="label ">Grupos:</label>
                                <div class="control has-icons-left has-icons-right ">
                                    <div class="select ">
                                        <ng-select2 [disabled]="ctrl.grupos ? ctrl.grupos.length==0 ? true : false : true " (valueChanged)="sCE($event, 'grupos_id');" [options]="ctrl.optionSelect " [data]="ctrl.grupos "></ng-select2>
                                    </div>
                                   <!--  <span class="icon is-small is-right ">
                                        <i class="fa fa-warning "></i>
                                    </span>
                                    <span class="help is-danger ">Este campo es requerido.</span> -->
                                </div>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column is-12">

                            </div>
                        </div>

                    </section>

                    <section style="padding: 1.1rem !important; overflow:auto;">
                        <table class="table is-striped is-fullwidth" *ngIf="repeticiones_materias.length">
                            <thead>
                                <tr>
                                    <th><abbr>ID</abbr></th>
                                    <th>Nombre de Materia</th>
                                    <th>Clave de Materia</th>
                                    <th>Nivel de Materia</th>
                                    <th>Nombre de Grupo</th>
                                    <th>Clave de Grupo</th>
                                    <th>Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of repeticiones_materias; let i=index">
                                    <td style="vertical-align: middle;">{{ i + 1 }}</td>
                                    <td>{{item.materias.nombre}}</td>
                                    <td>{{item.materias.clave}}</td>
                                    <td>{{item.materias.nivel}}</td>
                                    <td>{{item.grupos.clave}} Nivel: {{ item.grupos.nivel }}</td>
                                    <td>{{item.grupos.identificador}}</td>
                                    <td><button class="navbar-item  is-danger tooltip" type="button" [ngClass]="{'is-loading': cargando}" *ngIf="item.inscripciones_id==NULL && item.pago_completado==0" (click)="ctrl.eliminarDos(item.id)">
                                        <span class="icon fa-2x has-text-danger">
                                        <i class="icon-trash"></i>
                                        </span>
                                        <span class="tooltiptext">Eliminar</span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                </section>
            </form>
        </div>
    </div>
</div>


<div class="modal " id="confirmarCalificacion">
    <div class="modal-background "></div>
    <div class="modal-card ">
        <header class="modal-card-head ">
            <p class="modal-card-title ">
                <i class="fa fa-warning "></i> Alerta
            </p>
            <button (click)="ctrl.cancelarModal( 'confirmarCalificacion') " class="delete "></button>
        </header>
        <section class="modal-card-body ">
            <div class="content ">
                <h1>¿Esta seguro de guardar los cambios?</h1>
                <p>Esta acción podra afectar boletas impresas anteriormente</p>
            </div>
        </section>
        <footer class="modal-card-foot ">
            <a (click)="enviar() " [ngClass]="{ 'is-loading': borrarCargando} " class="button is-success ">Continuar</a>
            <a (click)="ctrl.cancelarModal( 'confirmarCalificacion') " class="button ">Cerrar</a>
        </footer>
    </div>
</div>